const env = process.env.NODE_ENV;

const getUrl = env => {
    switch (env) {
        case 'localhost':
            return `http://localhost:8000/forward`;

        case 'development':
            return `https://sports-notifications-dev.vi.ggops.com/forward`;

        case 'production':
            return `https://sports-notifications-prod.vi.ggops.com/forward`;

        default:
            return `https://sports-notifications-dev.vi.ggops.com/forward`;
    }
};

const sendEmails = async ids => {
    try {
        const url = getUrl(env);
        const Emailres = await fetch(url, {
            method: 'post',
            body: JSON.stringify({ ids }),
            headers: {
                'content-type': 'application/json',
            },
        });

        if (Emailres.status !== 200) {
            const error = new Error(
                Emailres.statusText || Emailres.status || Emailres.message,
            );
            error.response = Emailres;
            throw error;
        }

        const EmailJson = await Emailres.json();
        return EmailJson;
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
    }
};

export default sendEmails;
